import { render, staticRenderFns } from "./QuestionCalculatorComponent.vue?vue&type=template&id=52146c62&"
import script from "./QuestionCalculatorComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionCalculatorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionCalculatorComponent.vue?vue&type=style&index=0&id=52146c62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports